export const COMMERCIAL_LEASING_EMAIL = "commercial.leasing@fergmar.com";

export const RESIDENTIAL_LEASING_EMAIL = "leasing@fergmar.com";
